import React, {useState} from 'react'
import {diffOfferAndShipping} from "../../services/serviceReports";
import {Card, Row, Space, Table} from "antd";
import Filter from "../filterWrapper/Filter";
import {SearchOutlined} from "@ant-design/icons";
import DiffBetweenOfferShippingFilter from "./DiffBetweenOfferShippingFilter";
import Text from "antd/es/typography/Text";
import userDateFormatter from "../../services/formatters/userDateFormatter";
import { groupSubItemsByField } from '../../utils/helpers/commonFunctions';

const setTableRowKeys = (r, index) => index

const DiffBetweenOfferAndShippingOrder = () => {
    const [openFilter, setOpenFilter] = useState(false)
    const [tableData, setTableData] = useState([])

    const handleClear = () => setTableData([])
    const handleFilter = (...filterData) => {
        diffOfferAndShipping(filterData[0])
            .then(({data}) => {
                data.forEach(element => {
                    if(element.shippings && element.shippings.length > 1) {
                        const groupedShippings = groupSubItemsByField('c', element.shippings, ['bn', 'bsD', 'sn']);
                        element.shippings = [...groupedShippings];
                    }
                });
                setTableData(data)
            })    
        return new Promise((resolve, reject) => {
            resolve(true);
            reject(false);
        })
    }

    const mainColumns = [
        {
            title: 'Teklif No',
            dataIndex: 'bidNo',
            key: 'bidNo'
        },
        {
            title: 'Müşteri',
            dataIndex: 'customerName',
            key: 'customerName'
        },
        {
            title: 'Firma Yetkilisi',
            dataIndex: 'representative',
            key: 'representative'
        },
        {
            title: 'Teklif Tarihi',
            dataIndex: 'createdDate',
            key: 'createdDate',
            render: (t) => userDateFormatter(t)
        },
        {
            title: 'Oluşturan',
            dataIndex: 'createdBy',
            key: 'createdBy'
        },
    ]

    const expandedRowRender = (record) => {
        const subColumns = [
            {title: 'Stok Kodu', dataIndex: 'c', key: 'c'},
            {title: 'Stok Adı', dataIndex: 'n', key: 'n'},
            {title: 'Stok Açıklaması', dataIndex: 'd', key: 'd'},
            {title: 'Sevkiyat Numarası', dataIndex: 'dn', key: 'dn'},
            {title: 'Sevk Adeti', dataIndex: 'sn', key: 'sn'},
            {title: 'Teklif Adeti', dataIndex: 'bn', key: 'bn'},
            {title: 'Fark', dataIndex: 'bsD', key: 'bsD', render: (t) => t < 0 ? <Text type="danger">{t}</Text> : t}
        ]

        return(
            <React.Fragment>
                <Table rowKey={setTableRowKeys} columns={subColumns} scroll={{x: 'max-content'}} dataSource={record.shippings}  />
            </React.Fragment>
        )
    }

    const toggleFilterDisplay = () => setOpenFilter(!openFilter)
    return(
        <React.Fragment>
            <Card title={'Teklif Raporları'}>
                <Space direction={"vertical"} size={'large'} style={{width: '100%'}}>
                    <Row justify={"start"}>
                        <div className={'filter-row-container'} onClick={toggleFilterDisplay}><SearchOutlined/></div>
                    </Row>
                    <Table rowKey={setTableRowKeys} columns={mainColumns} dataSource={tableData} scroll={{x: 'max-content'}} expandable={{expandedRowRender}}/>
                </Space>
            </Card>
            {
                <Filter
                    showDrawer={openFilter}
                    closer={toggleFilterDisplay}
                    relatedComponent={'Teklif Raporları'}
                    handler={handleFilter}
                    resetHandler={handleClear}
                >
                    <DiffBetweenOfferShippingFilter />
                </Filter>
            }
        </React.Fragment>
    )
}
export default DiffBetweenOfferAndShippingOrder